module.exports = __webpack_public_path__ + "static/img/cp02.0d20e30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cp02.png
// module id = ZQj+
// module chunks = 1